import React, { useContext, useEffect } from 'react';
import "./SmallImageViewer.css";
import { DOCUMENT_PAGE_LIST } from '../../constants/GeneralConstants';
import { RenderScrollContext } from '../../contexts/RenderScrollContext';

import { AdditionalSignaturesContext } from '../../contexts/AdditionalSignaturesContext';

import { SignatureIndicator } from './../SvgComponents/SignatureIndicator/SignatureIndicator';
import DocumentMapService from '../../services/DocumentMapService';

export const SmallImageViewer = (props) => {
  const { setCurrentPage } = props;

  const { page, setPage, documentRendered: images } = useContext(RenderScrollContext);

  const { signatureBoxes } = useContext(AdditionalSignaturesContext);

  const currentPage = page.value;

  useEffect(() => {
    document.querySelectorAll('.highlight-page').forEach(e => e.classList.remove('highlight-page'));
    document.getElementById(`pdf-page-${currentPage}`)?.classList.add('highlight-page');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const changePage = (newPage) => {
    setCurrentPage(newPage);
    setPage({
      value: newPage,
      source: DOCUMENT_PAGE_LIST
    });
  };

  const loadedPages = DocumentMapService.getLoadedValues();
  let imagesList = images?.map((renderedImage, index) => {
    const page = loadedPages[index] + 1;
    let signatureBoxesData = signatureBoxes ? signatureBoxes : [];

    signatureBoxesData = signatureBoxesData.filter((box) => box.Page === page);

    const imageInfo = {
      Width: renderedImage.Width || 210, // Default A4 size
      Height: renderedImage.Height || 297, // Default A4 size
    };
    const signatureBoxesOfPage = signatureBoxesData.map((box, i) => {
      return <SignatureIndicator boxData={box} key={i} pageWidth={imageInfo.Width} />;
    });

    return (
      <div className='small-image-container' key={page}>
        <img
          onClick={() => changePage(page, DOCUMENT_PAGE_LIST)}
          key={page}
          alt="renderedImage"
          src={`data:image/jpeg;base64,${renderedImage.RenderedPageB64}`}
          className="small-image"
          id={`pdf-page-${page}`}
        />
        {signatureBoxesOfPage}
        <h6 className="small-number">{page}</h6>
      </div>
    );
  });

  return imagesList;
}